import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../shared/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {of} from "rxjs";
import {SessionStorage} from "ngx-webstorage";

@Component({
  standalone: false,
  selector: 'app-connect-idms',
  templateUrl: './connect-idms.component.html',
  styleUrls: ['./connect-idms.component.scss']
})
export class ConnectIdmsComponent implements OnInit {

  @SessionStorage() gaLoginTrigger: boolean;

  isGettingAccessToken = false;
  constructor(private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.gaLoginTrigger = false;
        this.isGettingAccessToken = true;
        return this.authService.getAccessToken(params['code']).subscribe({
          next: result => {
            this.authService.saveToken(result);
            this.router.navigateByUrl('/projects');
          },
          error: () => {
            this.isGettingAccessToken = false;
          }
        });
      } else {
        return of(null);
      }
    });
  }

  public relogin () {
    this.gaLoginTrigger = false;
    this.authService.login();
  }
}
